import { __assign, __extends, __rest } from "tslib";
import React, { PureComponent } from 'react';
import { ButtonNext } from 'wix-ui-core/dist/es/src/components/button-next';
import Ellipsis from '../common/Ellipsis';
import { TooltipCommonProps } from '../common/PropTypes/TooltipCommon';
import { generateDataAttr } from '../utils/generateDataAttr';
import { classes, st } from './Button.st.css';
import PropTypes from 'prop-types';
import { WixStyleReactDefaultsOverrideContext } from '../WixStyleReactDefaultsOverrideProvider';
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.button = React.createRef();
        /**
         * Sets focus on the element
         */
        _this.focus = function () {
            _this.button.current && _this.button.current.focus();
        };
        return _this;
    }
    Button.prototype.render = function () {
        var _this = this;
        var buttonPropsDefaults = this.context.button;
        var _a = this.props, _b = _a.skin, skin = _b === void 0 ? 'standard' : _b, _c = _a.priority, priority = _c === void 0 ? 'primary' : _c, _d = _a.size, size = _d === void 0 ? buttonPropsDefaults.size : _d, className = _a.className, fullWidth = _a.fullWidth, children = _a.children, dataHook = _a.dataHook, ellipsis = _a.ellipsis, showTooltip = _a.showTooltip, _e = _a.tooltipProps, tooltipProps = _e === void 0 ? {} : _e, rest = __rest(_a, ["skin", "priority", "size", "className", "fullWidth", "children", "dataHook", "ellipsis", "showTooltip", "tooltipProps"]);
        return (React.createElement(Ellipsis, __assign({ ellipsis: ellipsis, showTooltip: showTooltip }, tooltipProps, { render: function (_a) {
                var ref = _a.ref, ellipsisClasses = _a.ellipsisClasses;
                return (React.createElement(ButtonNext, __assign({}, rest, generateDataAttr(__assign(__assign({}, _this.props), { size: size }), ['skin', 'size', 'priority']), { ref: _this.button, className: st(classes.root, {
                        fluid: !!fullWidth,
                        skin: skin,
                        priority: priority,
                        size: size,
                        ellipsis: !!ellipsis,
                    }, className), "data-hook": dataHook, contentClassName: ellipsisClasses(), contentRef: ref }), children));
            } })));
    };
    Button.contextType = WixStyleReactDefaultsOverrideContext;
    Button.displayName = 'Button';
    Button.propTypes = {
        /** render as some other component or DOM tag */
        as: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.string,
        ]),
        /** Additional classes */
        className: PropTypes.string,
        /** Skins of Button content */
        skin: PropTypes.oneOf([
            'standard',
            'inverted',
            'destructive',
            'premium',
            'dark',
            'light',
            'transparent',
            'premium-light',
        ]),
        /** Priority of Button content */
        priority: PropTypes.oneOf(['primary', 'secondary']),
        /** Size of Button content */
        size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large']),
        /** Click event handler  */
        onClick: PropTypes.func,
        /** Sets button width to 100% */
        fullWidth: PropTypes.bool,
        /** Element based icon (svg, image etc.) */
        suffixIcon: PropTypes.element,
        /** Element based icon (svg, image etc.) */
        prefixIcon: PropTypes.element,
        /** Applies disabled styles */
        disabled: PropTypes.bool,
        /** String based node */
        children: PropTypes.node,
        /** String based data hook */
        dataHook: PropTypes.string,
        /** Should the text get ellipsized with tooltip, or should it get broken into lines when it reaches the end of its container */
        ellipsis: PropTypes.bool,
        /** True by default, set it to false in order to show ellipsis without a tooltip. */
        showTooltip: PropTypes.bool,
        /** Props that modify the Tooltip created from text ellipsis */
        tooltipProps: PropTypes.shape(TooltipCommonProps),
    };
    return Button;
}(PureComponent));
export default Button;
//# sourceMappingURL=Button.js.map